import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const generateDateLabels = (days) => {
  const labels = [];
  const dates = [];
  const today = new Date();
  for (let i = days; i >= 0; i--) {
    const date = new Date(today);

    date.setDate(today.getDate() - i);
    labels.push(date.toISOString().split("T")[0]);
    dates.push(date);
  }

  return { labels, dates };
};

const countIncommingOrders = (orders, dates, ordersOf) => {
  let checkOrders = "";
  if (ordersOf === "Kryzen") {
    checkOrders = "to kryzen";
  } else if (ordersOf === "Kryzen-CNF") {
    checkOrders = "to cnf";
  } else if (ordersOf === "Farmers") {
    checkOrders = "to farmer";
  }

  return dates.map((date) => {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    let revenue = 0;
    orders.filter((order) => {
      const createdAt = new Date(order.createdAt);
      if (
        createdAt >= startOfDay &&
        createdAt <= endOfDay &&
        order.orderType.endsWith(checkOrders)
      ) {
        revenue += +order.totalAmount;
      }
    });

    return revenue;
  });
};

const RevenueChart = ({ ordersData, ordersFrom = 30, ordersOf = "All" }) => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    const { labels, dates } = generateDateLabels(ordersFrom);
    const ordersCountsIncomming = countIncommingOrders(
      ordersData,
      dates,
      ordersOf
    );

    const data = {
      labels: labels,
      datasets: [
        {
          label: "Daywise Revenue",
          data: ordersCountsIncomming,
          backgroundColor: "rgba(1, 50, 32, 0.5)",
          borderColor: "rgba(1, 100, 32, 1)",
          borderWidth: 1.5,
          tension: 0.5,
        },
      ],
    };
    setChartData(data);
  }, [ordersData, ordersFrom]);

  const options = {
    plugins: {
      tooltip: {
        theme: "dark",
      },
      legend: {
        display: true,
      },
    },
    responsive: true,
    layout: {
      padding: {
        top: 10,
        left: 10,
        right: 10,
        bottom: 10,
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "day",
        },
        stacked: true,
        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
          borderColor: "rgba(200, 200, 200, 0.6)",
        },
        ticks: {
          padding: 10,
          color: "#000",
        },
        title: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
          color: "rgba(200, 200, 200, 0.6)",
          borderColor: "rgba(200, 200, 200, 0.6)",
        },
        ticks: {
          padding: 10,
          color: "#000",
        },
      },
    },
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderColor: "rgba(0, 0, 0, 0.1)",
    borderWidth: 1,
    animation: {
      duration: 1000,
      easing: "easeOutQuart",
      loop: false,
    },
  };

  return <Line data={chartData} options={options} />;
};

export default RevenueChart;
